/**
 * Build /book/multi-stop URLs, optionally seeding from an A→B pair.
 */

const PUBLIC_MULTI_STOP = "https://qiktruck.co.za/book/multi-stop";

function cleanCoord(value) {
  if (value == null || value === "") return "";
  const n = Number(value);
  return Number.isFinite(n) ? String(n) : "";
}

/**
 * @param {{
 *   collection?: { address?: string, lat?: number|string, lng?: number|string },
 *   delivery?: { address?: string, lat?: number|string, lng?: number|string },
 *   absolute?: boolean,
 * }} [opts]
 */
export function buildMultiStopHref(opts = {}) {
  const params = new URLSearchParams();
  const from = opts.collection || {};
  const to = opts.delivery || {};

  if (from.address) params.set("from", String(from.address));
  if (to.address) params.set("to", String(to.address));

  const fromLat = cleanCoord(from.lat);
  const fromLng = cleanCoord(from.lng);
  const toLat = cleanCoord(to.lat);
  const toLng = cleanCoord(to.lng);
  if (fromLat) params.set("fromLat", fromLat);
  if (fromLng) params.set("fromLng", fromLng);
  if (toLat) params.set("toLat", toLat);
  if (toLng) params.set("toLng", toLng);

  const qs = params.toString();
  const path = qs ? `/book/multi-stop?${qs}` : "/book/multi-stop";
  return opts.absolute ? `https://qiktruck.co.za${path}` : path;
}

export function publicMultiStopHref(opts = {}) {
  return buildMultiStopHref({ ...opts, absolute: true }) || PUBLIC_MULTI_STOP;
}

/**
 * Read A→B seed stops from the multi-stop booking URL.
 * Returns null when there is nothing useful to seed.
 */
export function locationsFromAbQuery(search = "") {
  try {
    const params = new URLSearchParams(search || "");
    const from = String(params.get("from") || "").trim();
    const to = String(params.get("to") || "").trim();
    const fromLat = cleanCoord(params.get("fromLat"));
    const fromLng = cleanCoord(params.get("fromLng"));
    const toLat = cleanCoord(params.get("toLat"));
    const toLng = cleanCoord(params.get("toLng"));

    if (!from && !to && !fromLat && !toLat) return null;

    const mk = (role, address, lat, lng) => ({
      id: `seed-${role}-${Date.now()}`,
      role,
      address: address || "",
      lat: lat ? Number(lat) : null,
      lng: lng ? Number(lng) : null,
      stopType: role === "pickup" ? "pickup" : role === "delivery" ? "delivery" : "waypoint",
      contactName: "",
      contactPhone: "",
      accessNotes: "",
    });

    return [
      mk("pickup", from, fromLat, fromLng),
      mk("waypoint", "", "", ""),
      mk("delivery", to, toLat, toLng),
    ];
  } catch {
    return null;
  }
}
